import { createUseStyles } from 'react-jss';
import { ModalProps } from './';

export const useModalStyles = createUseStyles({
  root: {
    width: ({ size }: ModalProps) => {
      switch (size) {
        case 'small':
          return '400px';
        case 'large':
          return '700px';
        case 'medium':
        default:
          return '500px';
      }
    },
  },
  title: {
    fontSize: '18px',
    lineHeight: '25px',
    fontWeight: 'normal',
    marginBottom: '20px',
  },
  content: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 'normal',
    marginBottom: '40px',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& > *': {
      width: '85px',
    },
    '& > *:not(last-child)': {
      marginLeft: '15px',
    },
  },
});
